export default "__VITE_ASSET__4e8327af__"